import { IABTest } from "./interfaces/abtest.interface";
import { IAnalyticsPlugin } from "./interfaces/analytics-plugin.interface";
import { IPlugin } from "../../interfaces/plugin.interface";
import { IQuiz } from '../../interfaces/quiz.interface';
import { IAnalyticsData } from './interfaces/analytics-data.interface';
import { AnalyticsType } from "./enums/analytics-type.enum";
import { YaMetrikaCounter } from "./ya-metrika";
import { appConfig } from "../../config/app.config";
import { ReachGoalData } from "./interfaces/reach-goal-data.interface";
import { PostMessageEvent } from "../../enums/post-message-event.enum";
import { SendAnalyticsData } from "./interfaces/send-analytics-data.interface";
import { QuizEvent } from "../../enums/quiz-event.enum";
import { OwnAnalytics } from './own-analytics';
import { IApiProvider } from '../../interfaces/api-provider.interface';
import { VKPixel } from './vk-pixel';
import { AnalyticsEvent } from "./enums/analytics-event.enum";

export default class Analytics implements IPlugin {
  constructor(private readonly datas: IAnalyticsData[], private readonly apiProvider: IApiProvider) { }

  private plugins: IAnalyticsPlugin[] = [];
  private quiz: IQuiz;

  public readonly name = "analytics";

  public async getData() {
    return this.datas;
  }

  public init(quiz: IQuiz) {
    this.quiz = quiz;

    this.datas.forEach(data => {
      if (data.type == AnalyticsType.YA_METRIKA) this.plugins.push(new YaMetrikaCounter(Number(data.id), data.bindEventsList, data.prefix));
      if (data.type == AnalyticsType.OWN_ANALYTICS) this.plugins.push(new OwnAnalytics(String(data.id), this.apiProvider));
      if (data.type == AnalyticsType.VK_PIXEL) this.plugins.push(new VKPixel(String(data.id)));
    });

    this.plugins.forEach(plugin => plugin.init(quiz));

    this.quiz.bindPostMessageEvent<ReachGoalData>(PostMessageEvent.REACH_GOAL, message => {
      this.quiz.emitEvent(QuizEvent.REACH_GOAL, message.data);
    });

    this.quiz.bindPostMessageEvent<SendAnalyticsData>(PostMessageEvent.SEND_ANALYTICS, message => {
      this.track(message.data.event, message.data.params);
    });

    this.quiz.bindPostMessageEvent<IABTest>(PostMessageEvent.SET_AB_TEST, message => {
      this.setABTest(message.data);
    });
  }

  private track(event: AnalyticsEvent, params?: Record<string, any>) {
    this.plugins.forEach(plugin => plugin.track(event, params));
  }

  private setABTest(abTest: IABTest) {
    this.plugins.forEach(plugin => plugin.setABTest(abTest));
  }
}